import { AppProblemModel } from '~/services/api/AppProblemModel'
import { appendRequestReference } from '~/services/api/appendRequestReference'
import { fieldIssueMessage } from '~/services/api/fieldIssueMessage'
import { fieldIssuesMessage } from './fieldIssuesMessage'
import { problemReasonMessage } from '~/services/api/problemReasonMessage'
import { resolveProblemMessage } from '~/services/api/resolveProblemMessage'
import { resolveProblemMessageWithReference } from '~/services/api/resolveProblemMessageWithReference'
import { formValidation } from '~/services/forms/formValidation'

/** Presentation-zone access to problem normalization and display text. */
export const useProblemPresentation = () => ({
  applyProblemFieldErrors: formValidation.applyProblemFieldErrors,
  appendRequestReference,
  clearProblemFieldErrors: formValidation.clearProblemFieldErrors,
  fieldIssueMessage,
  fieldIssuesMessage,
  fromZodError: AppProblemModel.fromZodError,
  normalize: AppProblemModel.normalize,
  reasonMessage: problemReasonMessage,
  resolveMessage: resolveProblemMessage,
  resolveMessageWithReference: resolveProblemMessageWithReference
})
